import "core-js";
import DrawEpisodesMaps from "./modules/EpisodesMap";

DrawEpisodesMaps();
